// extracted by mini-css-extract-plugin
export default {"nav":"NavSwitch_nav__REQEW","disabled":"NavSwitch_disabled__k7xky","item":"NavSwitch_item__NnfnZ","active":"NavSwitch_active__-ns4S"};